export const defaultPlanType = 'FD';
export const allTemplateTypeCd = 'ALL';
export const defaultSelectBy = 'PQM';
export const InvNumSelectBy = 'IN';
export const planTypeMedicaid = 'Medicaid';
export const radioGroupLabelName = 'Plan Type';
export const rebateProgramLabelName = 'Rebate Program';
export const lemplateTypeName = 'Template Type';
export const coverTemplate = 'COVER';
export const disputeTemplate = 'DISPUTE';
export const collectTemplate = 'COLLECT';
export const printMedia = 'PRINT';
export const printDraft = 'PRINTDRAFT';
export const emailMedia = 'EMAIL';
export const eitherMedia = 'BOTH';
export const somethingWentWrong = 'somethingWentWrong';

export const selectByList = [
  { name: 'Program, Quarter, Manufacturer', value: 'PQM' },
  { name: 'Invoice Number', value: 'IN' },
];
